import React from 'react';
import axios from 'axios';

class Signin extends React.Component {
    state = {}

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleWrongPasswd = () => {
        alert('Username and Password do not match')
    }

    handleSubmit = (e) => {
        e.preventDefault()
        console.log("inside auth post")
        axios.post('/api/student', this.state)
            .then((res) => {
                console.log(res.data)
                if (res.data.bool === true) {
                    this.props.handleAuthState(res.data.data)
                    // this.props.changeData(res.data.data)
                } else {
                    this.handleWrongPasswd()
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    render() {
        return (
            <>
                <div className="container signin-div" >
                    <div className="row justify-content-sm-center">
                        <div className="col-sm-5 col-md-4">

                            <div className="card text-center signin-card">
                                <div className="card-body">
                                    <h4 className="text-center">Poll@School</h4>
                                    <form className="form-signin">
                                        <input type="text" className="form-control mb-2" placeholder="User_name" name="user_name" onChange={this.handleChange} required autofocus/>
                                        <input type="password" className="form-control mb-2" placeholder="Password" name="password" onChange={this.handleChange} required/>
                                        <button className="btn-lg btn-primary btn-block mb-1" type="submit" onClick={this.handleSubmit}>Sign in</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        );
    }
}

export default Signin;